import type { RbcPartnerMetadata } from "@b2bportal/rbc-accounts-api";

/**
 * RBC tiers the bonus-earn (3X Avion points) offer is available to. The offer is
 * gated to these tiers on the FE; LaunchDarkly targeting is not relied on for
 * tier eligibility.
 */
const ELITE_OR_PREMIUM_TIERS = ["elite", "premium"];

/**
 * The slice of session info the tier check reads. `userInfo` is `object`
 * because the shared `UserInfo` type does not declare `partnerMetadata`; RBC
 * receives it from the auth API as an untyped extra field.
 */
interface SessionWithUserInfo {
  userInfo?: object;
}

const getPartnerMetadata = (
  userInfo: object | undefined
): RbcPartnerMetadata | undefined =>
  userInfo != null && "partnerMetadata" in userInfo
    ? (userInfo.partnerMetadata as RbcPartnerMetadata | undefined)
    : undefined;

/**
 * Whether the session user is Elite or Premium. Tier comes from RBC partner
 * metadata (`tierEn`); false when unknown / signed out.
 *
 * Pure so both the React hook and the XState tracking selector can use it.
 */
export const isEliteOrPremiumTier = (
  sessionInfo: SessionWithUserInfo | undefined
): boolean => {
  const partnerMetadata = getPartnerMetadata(sessionInfo?.userInfo);
  const tier = partnerMetadata?.tierEn?.toLowerCase();
  return tier != null && ELITE_OR_PREMIUM_TIERS.includes(tier);
};
